import {
	createPageSegmentLoadMetric,
	createInteractionMetric,
} from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import {
	PAGE_TREE_SEGMENT_KEY,
	MOVE_PAGE_DIALOG_INTERACTION,
} from '@confluence/browser-metrics/entry-points/metric-keys.ts';
export const PAGE_TREE_METRIC = createPageSegmentLoadMetric({
	key: PAGE_TREE_SEGMENT_KEY,
	ssr: Boolean(window.__SSR_RENDERED__) ? { doneAsFmp: true } : undefined,
});

export const MOVE_PAGE_DIALOG_INTERACTION_METRIC = createInteractionMetric({
	key: MOVE_PAGE_DIALOG_INTERACTION,
});
